<template>
  <div class="content">
    <section class="section-1">
      <div class="firstPart">
        <div class="info">
          <h2 class="font-size-big">System Vocale</h2>
          <p class="font-size-middle">
            Pierwszy nowoczesny i wygodny w obsłudze <strong>System Vocale</strong>
            stworzony specjalnie na potrzeby zespołów muzycznych do zarządzania utworami
            muzycznymi w czasie koncertu. Aktualnie grany utwór wyświetli się na wszystkich
            tabletach jednocześnie, a dostęp do systemu otrzymasz poprzez tablet, smartphone
            oraz komputer.
          </p>
        </div>
        <img class="image-placeholder" src="@/assets/images/product_1_1image.png"/>
      </div>

      <h2 class="font-size-big">Miej stały podgląd kto jest podłączony</h2>
      <div class="info">
        <p class="font-size-middle">
          Na stronie głównej Administrator zespołu ma stały podgląd którzy użytkownicy są
          podłączeni do <strong>Systemu Vocale.</strong> Pozostałym użytkownikom w momencie
          oczekiwania na przesłanie tekstu zostanie wyświetlony wygaszacz ekranu.
        </p>
      </div>
      <div class="image">
        <img class="image-placeholder" src="@/assets/images/product_1_connected_people.png"/>
      </div>

      <h2 class="font-size-big">Stwórz swoją kolekcję</h2>
      <div class="info">
        <p class="font-size-middle">
          Utwórz swoją muzyczną bibliotekę i zabierz ze sobą dokądkolwiek się udajesz.
        </p>
        <p class="font-size-middle">
          Skorzystaj z biblioteki globalnej, w której znajdują się piosenki najbardziej
          powtarzalne, lub możesz dodać własne w formie tekstu lub zdjęć.
        </p>
      </div>
      <div class="image">
        <img class="image-placeholder" src="@/assets/images/product_1_playlists.png"/>
      </div>


      <h2 class="font-size-big">Dostosuj muzykę podczas koncertu</h2>
      <div class="info">
        <p class="font-size-middle">
          W pełni funkcjonalny <strong>System Vocale</strong> pozwala podczas grania setu/
          koncertu dodawać piosenki do kolejki, usuwać piosenki lub zmieniać kolejność a
          każdy członek zespołu<br> zostanie poinformowany o tym w trybie rzeczywistym.
        </p>
      </div>
      <div class="image">
        <img class="image-placeholder1" src="@/assets/images/product_1_7image.png"/>
      </div>


      <h2 class="font-size-big">Gdziekolwiek jesteś - Vocale Offline będzie z Tobą</h2>
      <div class="info">
        <p class="font-size-middle">
          Dzięki zastosowaniu inteligentnej infrastruktury, <strong>System Vocale</strong>
          działa offline (bez dostępu do internetu), aby wyświetlać szybko piosenki na wszystkich
          urządzeniach zespołu jednocześnie bez względu na to czy jest internet w miejscu koncertu.
        </p>
      </div>
      <div class="image">
        <img class="image-placeholder" src="@/assets/images/product_1_connectTablet.png"/>
      </div>


      <h2 class="font-size-big">Niezawodne przechowywanie danych</h2>
      <div class="info">
        <p class="font-size-middle">
          Nasz zespół zdaje sobie sprawę jak ważne jest dla Ciebie zadowolenie uczestników imprezy,
          dlatego <strong>System Vocale</strong> zabezpieczy Twój śpiewnik w chmurze do którego
          masz dostęp kiedy tylko zechcesz.
        </p>
      </div>
      <div class="image">
        <img class="image-placeholder" src="@/assets/images/product_1_logoVocale.png"/>
      </div>

      <h2 class="font-size-big">Zacznij w 3 prostych krokach</h2>
      <div class="image">
        <img class="image-placeholder" src="@/assets/images/product_1_3image.png"/>
      </div>

    </section>
  </div>
</template>

<script>
export default {
  name: 'VocaleSystem',
}
</script>

<style lang='scss' scoped>
@import "@/assets/scss/_variables.scss";

.content {
  grid-area: content;
  padding: 0 20px;

  .text-header {
    padding: 20px 0;
    text-align: center;
    color: white;

    strong {
      color: $primary;
    }
  }

  .section-1 {
    justify-content: center;
    margin-bottom: 40px;
    color: white;
    font-size: 24px;
    text-align: center;

    h2 {
      color: $primary;
    }

    .firstPart {
      margin-top: 100px;
      margin-bottom: 75px;
      flex: 1 1;
      display: flex;
      justify-content: space-evenly;

      .info {
        width: fit-content;
        text-align: center;
        font-size: 23px;
        margin: 0;

        p {
          max-width: 700px;
          width: 540px;
          margin: 70px auto;
        }

      }

      .image-placeholder {
        width: 650px;
        height: 100%;
        margin: 0;
      }
    }

    .info {
      width: 80%;
      margin: 0 auto;

      p {
        margin: 0 auto;
      }
    }

    .image {
      flex: 1 1;
      display: flex;

      .image-placeholder {
        max-width: 750px;
        background-color: black;
        margin: 0 auto;
        margin-bottom: 40px;
      }

      .image-placeholder1 {
        width: 500px;
        margin: 20px auto;
      }
    }

    strong {
      color: $primary;
    }

  }
}

@media (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
  .content {
    justify-content: center;
    align-items: center;
    padding: 0;

    h1 {
      font-size: 1.2em;
      text-align: center;
      margin: 30px 0;
    }

    .section-1 {
      display: grid;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;

      .firstPart {
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;

        h2 {
          margin-bottom: -50px;
        }

        .image-placeholder {
          max-width: 500px;
        }

        .info {
          max-width: 100%;

          p {
            width: 100%;
            margin-bottom: 20px;
          }
        }
      }

      .info {
        margin: 20px auto 0;
        width: 100%;
      }

      h2 {
        margin: 0 auto 10px;
      }

      .image {
        display: block;
        margin: 20px 0 0 0;

        .image-placeholder {
          max-width: 500px;
          margin-bottom: 0;
        }

        .image-placeholder1 {
          max-width: 270px;
        }
      }
    }
  }
}

// Mobile style
@media (max-width: $phone-max-width) {
  .content {
    justify-content: center;
    align-items: center;
    padding: 0;

    h1 {
      font-size: 1.2em;
      text-align: center;
      margin: 30px 0;
    }

    .section-1 {
      display: grid;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;

      .firstPart {
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;

        h2 {
          margin-bottom: -50px;
        }

        .image-placeholder {
          max-width: 200px;
        }

        .info {
          max-width: 100%;

          p {
            width: 100%;
            margin-bottom: 20px;
          }
        }
      }

      .info {
        margin: 20px auto 0;
        width: 100%;
      }

      h2 {
        margin: 0 auto 10px;
      }

      .image {
        display: block;
        margin: 20px 0 0 0;

        .image-placeholder {
          max-width: 270px;
          margin-bottom: 0;
        }

        .image-placeholder1 {
          max-width: 270px;
        }
      }
    }
  }
}

@media screen and (min-width: 600px) and (max-width: $phone-max-width){
  .image-placeholder {
    max-width: 500px !important;
  }
}
</style>

